import { FormattedMessage } from "react-intl";
import type { DateFieldError } from "@/lib/date-instant";

// Shared inline date-validation warning for the in-line merge review's date
// fields (collection MONTH fields + person_detail dateOfBirth). A field is
// edited as free text / a native date input, so an out-of-range or malformed
// value can be entered; this surfaces WHY, underneath the field, without
// blocking typing. Neutral field-meta text only — never a red/accent border
// (neutral-state-signals rule). Show/hide timing lives in useDateFieldWarning.
export function MergeDateWarning({ error }: { error: DateFieldError | null }) {
  if (!error) return null;
  // Not role="alert": a blocked save can reveal several of these at once, and N
  // simultaneous assertive live regions read as an unattributed burst. The bar's
  // single "some dates need fixing" alert carries the assertive cue; these notes
  // are field-adjacent and read in place.
  return (
    <div className="field-meta mt-0.5 text-ink/55" data-testid="profile-merge-date-warning">
      {error === "future" ? (
        <FormattedMessage
          id="profile.merge.date.future"
          defaultMessage="This date can't be in the future."
        />
      ) : error === "range" ? (
        <FormattedMessage
          id="profile.merge.date.range"
          defaultMessage="End date must be on or after the start date."
        />
      ) : error === "beforeBirth" ? (
        <FormattedMessage
          id="profile.merge.date.beforeBirth"
          defaultMessage="This date is before the date of birth."
        />
      ) : (
        <FormattedMessage
          id="profile.merge.date.format"
          defaultMessage="Use a date like YYYY, YYYY-MM or YYYY-MM-DD."
        />
      )}
    </div>
  );
}
